import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {Router} from '@angular/router';
import {DataService} from '../services/data.service';
import {SessionStorageService} from '../services/session-storage.service';
import {finalize, tap} from 'rxjs/operators';
import {TranslationService} from '../services/translation.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnChanges {

    @Input() userInfo: any;
    @Input() pageName: any;
    language = 'ro';
    isSavingLanguage = false;

    constructor(
        private restService: RestService,
        private uiBlockerService: UIBlockerService,
        private router: Router,
        private dataService: DataService,
        private localStorage: SessionStorageService,
        private translationService: TranslationService
    ) { /* noop */
    }

    ngOnInit() { /* noop */
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.userInfo && this.userInfo) {
            this.language = this.userInfo.Language === 'en' ? 'en' : 'ro';
            this.translationService.setLanguage(this.language);
        }
    }

    changeLanguage(language: string) {
        if (!this.userInfo || this.isSavingLanguage) {
            return;
        }

        const previousLanguage = this.language;
        this.language = language === 'en' ? 'en' : 'ro';
        this.translationService.setLanguage(this.language);
        this.isSavingLanguage = true;

        this.restService.updateAdminProfile({
            Name: this.userInfo.Name,
            Email: this.userInfo.Email,
            Language: this.language,
            CurrentPassword: '',
            NewPassword: '',
            NewPasswordConfirmation: ''
        }).pipe(
            finalize(() => {
                this.isSavingLanguage = false;
            })
        ).subscribe((response: any) => {
            if (this.dataService.isResponseSuccessful(response) && response.UserInfo) {
                this.dataService.setUserInfo(response.UserInfo);
                return;
            }

            this.language = previousLanguage;
            this.translationService.setLanguage(previousLanguage);
        }, () => {
            this.language = previousLanguage;
            this.translationService.setLanguage(previousLanguage);
        });
    }

    openProfile() {
        this.router.navigate(['/central/profile']);
    }

    logOutClicked() {
        // we need to to the following things
        // 1) remove session from local storage
        this.deleteSessionFromLocalStorage();
        // 2) remove session from server via new call
        this.removeSessionIdFromServer();
        // 3) redirect to login page
        this.router.navigate(['/login']);
    }

    deleteSessionFromLocalStorage() {
        // Clear all since we have only session identifier kept here.
        this.localStorage.clear().subscribe(() => { /* noop */
        });
    }

    removeSessionIdFromServer() {
        this.restService.logout()
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                }),
                tap(
                    () => {
                        /* noop */
                    },
                    () => {
                        /* noop */
                    }
                )
            ).subscribe(() => {
            /* noop */
        });
    }

}
